/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Card, Col, Row, Typography } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import '../styles.less'

const { Title, Text } = Typography

interface RewriteParentOfferProps {
  parentOfferId: string
  parentOfferOldExpirationDate?: number
  parentOfferNewExpirationDate?: number
}

const formatDate = (sec?: number): string => sec ? dayjs(sec * 1000).format('YYYY-MM-DD') : '-'

export function RewriteParentOffer({
  parentOfferId,
  parentOfferOldExpirationDate,
  parentOfferNewExpirationDate
}: RewriteParentOfferProps) {
  const { t } = useTranslation()

  return (
    <Card>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <div className="section-indicator-success" style={{ width: 8, height: 8, borderRadius: '50%', marginRight: 8 }} />
        <Title level={4} className="section-title" style={{ margin: 0 }}>
          {t('Rewrites Parent Offer')}
        </Title>
      </div>

      <Row gutter={[24, 16]} style={{ margin: '0 16px' }}>
        <Col span={8}>
          <Text className="section-title" style={{ fontSize: 14 }}>{t('Parent Offer ID')}</Text>
          <div style={{ marginTop: 6 }}>
            <Text style={{ fontSize: 16, fontWeight: 'bold' }}>
              {parentOfferId}
            </Text>
          </div>
        </Col>
        <Col span={8}>
          <Text className="section-title" style={{ fontSize: 14 }}>{t('Parent Original Expiration Date')}</Text>
          <div style={{ marginTop: 6 }}>
            <Text style={{ color: 'var(--private-offer-bg-primary)', fontSize: 16, fontWeight: 'bold' }}>
              {formatDate(parentOfferOldExpirationDate)}
            </Text>
          </div>
        </Col>
        <Col span={8}>
          <Text className="section-title" style={{ fontSize: 14 }}>{t('Parent New Expiration Date')}</Text>
          <div style={{ marginTop: 6 }}>
            <Text style={{ color: '#faad14', fontSize: 16, fontWeight: 'bold' }}>
              {formatDate(parentOfferNewExpirationDate)}
            </Text>
          </div>
        </Col>
      </Row>
    </Card>
  )
}
